import { openBlock as r, createElementBlock as n, Fragment as u, renderList as h, createElementVNode as s, toDisplayString as t, createCommentVNode as i, createTextVNode as l } from "vue";
import { _ as d } from "./index-B_KFPBbP.mjs";
function g(e) {
  switch (e) {
    case "€":
      return "EUR";
    case "$":
      return "USD";
    case "円":
      return "JPY";
    case "원":
      return "KRW";
    case "£":
      return "GBP";
    case "AUD":
    case "CHF":
    case "CAD":
    case "NZD":
    default:
      return e;
  }
}
const k = {
  name: "NaviCurrentShoppingcart",
  props: {
    shoppingcart: Array
  },
  setup() {
    return {
      getPreis: (e) => parseFloat(e.price === null ? 0 : e.price),
      getCurrenyFromSymbol: g
    };
  }
}, m = {
  key: 0,
  class: "km__list--modules shoppingcart--preview"
}, y = ["data-id"], v = { class: "km__navi__shoppingcart--preview" }, f = ["src", "alt"], C = { class: "km__navi__shoppingcart--content" }, S = { class: "km__navi__shoppingcart--title" }, w = { class: "km__navi__shoppingcart--quantity" }, F = { class: "km__navi__shoppingcart--price" }, P = { key: 0 }, A = { key: 1 };
function N(e, _, o, p, $, b) {
  return r(), n("div", null, [
    o.shoppingcart.length !== 0 ? (r(), n("ul", m, [
      (r(!0), n(u, null, h(o.shoppingcart, (a, c) => (r(), n("li", {
        class: "km__list__element",
        key: c
      }, [
        c < 3 ? (r(), n("div", {
          key: 0,
          class: "km__shoppingcart--previe--wrapper",
          "data-id": c
        }, [
          s("div", v, [
            s("img", {
              class: "km__navi__shoppingcart--image",
              src: a.imageURL,
              alt: a.productShort
            }, null, 8, f)
          ]),
          s("div", C, [
            s("span", S, t(a.productShort), 1),
            s("span", w, t(e.$t("konf_Amount")) + " " + t(a.anz) + " " + t(e.$t("Stück")), 1),
            s("span", F, t(e.$n(p.getPreis(a), { key: "currency", currency: p.getCurrenyFromSymbol(a.waehrung) })), 1)
          ])
        ], 8, y)) : i("", !0)
      ]))), 128))
    ])) : i("", !0),
    o.shoppingcart.length > 3 ? (r(), n("button", {
      key: 1,
      onClick: _[0] || (_[0] = (a) => e.$emit("openShoppingCart")),
      class: "km__button--link"
    }, [
      s("span", null, t(o.shoppingcart.length - 3), 1),
      l("  "),
      o.shoppingcart.length === 4 ? (r(), n("span", P, t(e.$t("konf_weitererPosten_orders_singular")), 1)) : (r(), n("span", A, t(e.$t("konf_weiterePosten_orders_plural")), 1)),
      l("  "),
      s("span", null, t(e.$t("konf_ProduktImWarenkorbSolo")), 1)
    ])) : i("", !0)
  ]);
}
const B = /* @__PURE__ */ d(k, [["render", N], ["__scopeId", "data-v-882cf814"]]);
export {
  B as default
};
